import classNames from 'classnames';
import {
  CustomFormattedMessage,
  TranslationsKeys,
} from '../../../../i18n/i18n';
import { openUserManualDialog } from '../../../../state/dialogs/useUserManualDialog';
import { useAppDispatch } from '../../../../state/hooks';
import { UserManualDialogChaptersKeys } from '../../../../state/dialogs/chapters';
import { openSupportDialog } from '../../../../state/dialogs/useSupportDialog';

type ChapterTextProps = {
  messageId: TranslationsKeys;
  className?: string;
  colSize?: number;
  colSizeMd?: number;
  marginBottom?: number;
  referenceToChapter?: UserManualDialogChaptersKeys;
  externalLink?: string;
};

export const ChapterText = ({
  messageId,
  className,
  colSize = 12,
  colSizeMd,
  marginBottom = 25,
  referenceToChapter,
  externalLink,
}: ChapterTextProps) => {
  const dispatch = useAppDispatch();
  let colSizeMdClass = '';
  if (colSizeMd) {
    colSizeMdClass = `col-md-${colSizeMd}`;
  }
  return (
    <div
      className={classNames(
        `col-xs-${colSize} ${colSizeMdClass} margin-bottom-${marginBottom}`,
        className,
      )}
    >
      <CustomFormattedMessage
        id={messageId}
        values={{
          support: (content) => (
            <button
              type="button"
              className={
                'border-none bg-none padding-0 text-color-primary text-medium text-decoration-underline'
              }
              onClick={() => {
                dispatch(openSupportDialog());
              }}
            >
              {content}
            </button>
          ),
          link: (content) => (
            <a
              className={'text-decoration-underline'}
              onClick={() =>
                dispatch(openUserManualDialog(referenceToChapter!))
              }
            >
              {content}
            </a>
          ),
          externalLink: (content) => (
            <a
              className={'text-decoration-underline'}
              href={externalLink}
              target="_blank"
              rel="noopener noreferer noreferrer"
            >
              {content}
            </a>
          ),
        }}
      />
    </div>
  );
};
